mod.modules.define("ExpandedModule", function(fn) {
	"use strict";

	fn.prototype.init = function(params) {
		this.initTooltips();
	};

	fn.prototype.initTooltips = function() {
		this.el.find("a.tooltip-trigger").tooltip({ html: true });
	};

	fn.prototype.events = {
		".module-close": {
			"click": function(e, $el) {
				this.el.closest(".modal").modal("hide");
			}
		},
		".view-toggle": {
			"click": function(e, $el) {
				e.preventDefault();
				$("div[data-view]", $el.parents("div.module-content")).toggleClass("none");
				var text = $("span", $el).text();
				$("span", $el).text(text == "Show" ? "Hide" : "Show");
			}
		}
	};

});